import {AnyAction, ListenerEffect} from '@reduxjs/toolkit';
import {AppDispatch, ExtraArgs} from '../../createStore';
import {RootState} from '../../rootReducer';
import {getUserAnnouncements} from '../../data/employeeCommunication/actions';

export const getUserAnnouncementsEffect: ListenerEffect<AnyAction, RootState, AppDispatch, ExtraArgs> = (
  _action,
  {dispatch},
) => {
  dispatch(getUserAnnouncements());
};
